<template>
	<div class="ReportMetaPeople">
		<!-- People icon -->
		<CloIcon symbol="users" size="sm" class="ReportMetaPeople-icon" />

		<!-- List of people -->
		<ul class="ReportMetaPeople-list u-people-inline">
			<li v-for="person in peopleRankedLimited" :key="person.userId">
				<Person :person="person"></Person>
			</li>
			<CloButton v-if="peopleRanked.length > maxPeopleDisplay" @click.native="showDialog" size="xs" class="Button--hollow">
				<span>{{ $t('generic.plusNumMore', [peopleRanked.length - maxPeopleDisplay]) }}</span>
			</CloButton>
		</ul>

		<!-- Full regions dialog -->
		<CloDialog v-show="dialogOpen" id="people-dialog" class="u-color-vars" @close="closeDialog">
			<template #header>
				<CloHeading level="4" size="2">{{ $t('tripReport.people') }} ({{peopleRanked.length}})</CloHeading>
			</template>
			<template #body>
				<ul class="ReportMetaPeople-list">
					<li v-for="person in peopleRanked" :key="person.userId">
						<Person :person="person"></Person>
						<!-- <span v-if="person.role !== 'participant'"> (Trip Report {{person.role}})</span> -->
					</li>
				</ul>
			</template>
		</CloDialog>

	</div>
</template>

<script>
import CloIcon from '@/icons/CloIcon/CloIcon.vue';
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import Person from './Person.vue';
export default {
	name: 'ReportMetaPeople',
	components: {
		CloIcon,
		CloHeading,
		Person,
	},
	props: {
		reverse: Boolean,
		confirmedPeople: Array,
		regions: Object,
	},
	computed: {
		peopleRanked() {
			let peopleRanked = [];
			let owners = this.confirmedPeople.filter((person) => person.role === 'owner');
			let editors = this.confirmedPeople.filter((person) => person.role === 'editor');
			let participants = this.confirmedPeople.filter((person) => person.role === 'participant');
			return peopleRanked.concat(owners, editors, participants);
		},
		peopleRankedLimited() {
			return this.peopleRanked.slice(0, this.maxPeopleDisplay);
		},
	},
	data() {
		return {
			baseUrl: window.baseUrl,
			dialogOpen: false,
			dialogOpener: null,
			maxPeopleDisplay: 5, // maxium people to display before truncating list
		};
	},
	methods: {
		showDialog(e) {
			this.dialogOpen = true;
			this.dialogOpener = e.target;
		},
		closeDialog() {
			this.dialogOpen = false;
			// important: put focus back on element that triggered the dialog
			if (this.dialogOpener) {
				this.dialogOpener.focus();
			}
		},
	},
};
</script>

<style lang="scss">
.ReportMetaPeople {
	display: flex;
	gap: $space-sm;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include inline-sm;
		}
	}
	.ReportMetaPeople-icon.Icon--users {
		color: var(--color-text-muted);
		opacity: 0.5;
		transform: translateY(0.15em);
		flex-shrink: 0;
	}
	.ReportMetaPeople-list {
		color: var(--color-text-muted);
		@include text(4, loose);
		list-style: none;
		margin: 0;
		[dir='rtl'] & {
			margin: 0;
		}
	}
	.ReportMetaPeople-list.u-people-inline {
		@include text(3, loose);
		display: flex;
		flex-wrap: wrap;
		column-gap: $space-rel-sm;
		margin: 0;
		li:not(:last-of-type)::after {
			color: var(--color-text-muted);
			opacity: 0.5;
			content: ',';
		}
	}
	a,
	.Button,
	.Button.Button--hollow {
		color: var(--color-link);
		border-color: var(--color-link-border);
		a:link,
		a:visited {
			color: var(--color-link);
			border-color: var(--color-link-border);
		}
		a:hover,
		a:active {
			color: var(--color-link-hover);
			border-color: var(--color-link-hover);
		}
	}
	.Button.Button--hollow {
		margin: 0;
		padding: $space-rel-xs $space-rel-sm;
		// transform: translateY(-.2em);
		display: inline-flex;
		align-items: center;
		align-self: center;
		gap: $space-xs;
		.Icon {
			width: 1.25em;
			height: 1.25em;
		}
	}
}

.print {
	.ReportMetaPeople {
		.Icon {
			opacity: 1;
			// width: 1.5rem;
			// height: 1.5rem;
		}
		color: var(--color-text);
		a {
			color: var(--color-text);
		}
		.Button {
			display: none;
		}
		.ReportMetaPeople-list.u-people-inline {
			// @include text(4, loose);
		}
	}
}
</style>
